import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-svg-icon"
}
const _hoisted_2 = ["onClick"]

import {ref} from "vue";
import SvgIcon from "./SvgIcon.vue"
import {icons} from "./extends";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectIcon',
  props: {
  value: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    default: "30",
  },
  width: {
    type: String,
    default: "30"
  }
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const visible = ref<boolean>(false)

const clickIcon = (icon: string) => {
  visible.value = false
  emit("update:value", icon)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value=!visible.value)),
      title: "点击选择"
    }, [
      _createVNode(SvgIcon, {
        icon: __props.value || 'choice',
        width: __props.width,
        height: __props.height
      }, null, 8, ["icon", "width", "height"])
    ]),
    (visible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(icons), (item) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "icon-item",
              onClick: ($event: any) => (clickIcon(item.icon)),
              key: item.icon
            }, [
              _createVNode(SvgIcon, {
                icon: item.icon,
                width: __props.width,
                height: __props.height
              }, null, 8, ["icon", "width", "height"])
            ], 8, _hoisted_2))
          }), 128)),
          _cache[1] || (_cache[1] = _createElementVNode("i", null, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("i", null, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("i", null, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("i", null, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("i", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("i", null, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})